// client/src/components/unidades/UnidadeCard.js
import React from 'react';
import { MoreVertical, CheckCircle, XCircle } from 'lucide-react';

const UnidadeCard = ({ unidade, onOpenActions }) => {
    if (!unidade) return null;

    const isAtivo = unidade.ativo !== false;
    const localidade = [
        unidade.endereco?.localidade,
        unidade.endereco?.uf
    ].filter(Boolean).join('/');

    return (
        <div className={`bg-white border rounded-lg p-4 hover:shadow-md transition-shadow flex flex-col justify-between h-full ${
            !isAtivo ? 'opacity-60 bg-gray-50' : ''
        }`}>
            <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between mb-2">
                    <h3 className="font-semibold text-gray-900 line-clamp-2">
                        {unidade.nome}
                    </h3>
                </div>
                
                <div className="text-sm text-gray-600 font-medium mb-3">
                    {localidade || 'Localidade não informada'}
                </div>
                
                <div>
                    {isAtivo ? (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                            <CheckCircle size={12} className="mr-1" /> Ativo
                        </span>
                    ) : (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 border border-red-200">
                            <XCircle size={12} className="mr-1" /> Inativo
                        </span>
                    )}
                </div>
            </div>

            <div className="mt-4 pt-3 border-t border-gray-100 flex justify-end">
                <button
                    onClick={() => onOpenActions(unidade)}
                    className="action-icon-button text-gray-600"
                    title="Ações"
                    type="button"
                >
                    <MoreVertical size={18} />
                </button>
            </div>
        </div>
    );
};

export default UnidadeCard;